module.exports = __webpack_public_path__ + "img/filtration-combo2.746a3a7f.jpg";